import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import lauraPhoto from './photos/laura.png';
import olenaPhoto from './photos/olena.png';
import sheelonPhoto from './photos/sheelon.png';

import css from './People.module.css';

const people = [
  {
    id: 'laura',
    photo: lauraPhoto,
    photoClassName: css.laura,
    nameId: 'AboutPeople.lauraName',
    name: 'Laura Groppe',
    roleId: 'AboutPeople.lauraRole',
    role: 'Founder & CEO',
    textId: 'AboutPeople.lauraText',
    text:
      'Built PostPartners from her own postpartum experience, navigating a fragmented system and deciding to rebuild it. Previously in New York real estate, now focused on professionalizing perinatal care.',
  },
  {
    id: 'olena',
    photo: olenaPhoto,
    photoClassName: css.olena,
    nameId: 'AboutPeople.olenaName',
    name: 'Olena Dobczansky',
    roleId: 'AboutPeople.olenaRole',
    role: 'Clinical Advisor',
    credentialsId: 'AboutPeople.olenaCredentials',
    credentials: 'MSN, RNC-MNN, IBCLC, C-ONQS, LCCE',
    textId: 'AboutPeople.olenaText',
    text:
      'A registered nurse and lactation consultant who set the clinical vetting standard at PostPartners. Olena advises on provider credentialing and ensures the platform reflects the real realities of perinatal care.',
  },
  {
    id: 'sheelon',
    photo: sheelonPhoto,
    photoClassName: css.sheelon,
    nameId: 'AboutPeople.sheelonName',
    name: 'Sheelon Aghili',
    roleId: 'AboutPeople.sheelonRole',
    role: 'Medical Advisor',
    credentialsId: 'AboutPeople.sheelonCredentials',
    credentials: 'Physician Assistant',
    textId: 'AboutPeople.sheelonText',
    text:
      "A physician assistant in gynecology who brings medical credibility to the PostPartners network, supporting the platform's commitment to qualified, trustworthy care.",
  },
];

/**
 * The people who built PostPartners, in the order shown on the about page.
 */
const People = () => (
  <section className={css.root}>
    <div className={css.inner}>
      <h2 className={css.title}>
        <FormattedMessage id="AboutPeople.title" defaultMessage="The people behind it" />
      </h2>
      <ul className={css.list}>
        {people.map(person => (
          <li key={person.id} className={css.person}>
            <img className={person.photoClassName} src={person.photo} alt="" />
            <div>
              <p className={css.role}>
                <FormattedMessage id={person.roleId} defaultMessage={person.role} />
              </p>
              <h3 className={css.name}>
                <FormattedMessage id={person.nameId} defaultMessage={person.name} />
              </h3>
              {person.credentialsId ? (
                <p className={css.credentials}>
                  <FormattedMessage id={person.credentialsId} defaultMessage={person.credentials} />
                </p>
              ) : null}
              <p className={css.text}>
                <FormattedMessage id={person.textId} defaultMessage={person.text} />
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default People;
